<template>
  <div class="modal_wrapper active">
    <div
      id="schedule_report"
      class="modal_window white_box"
      @click="datepicker = false"
    >
      <button
        class="close_modal close_btn schedule_step"
        @click.stop="$emit('close')"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h3
        v-if="currentStep < 3"
        class="heading_h4 font_bold mb_16 schedule_step"
      >
        {{ schedule ? 'Edit ' : '' }}Schedule
        Report
      </h3>

      <div
        v-if="currentStep === 1"
        class="section_modal_content white_box edit_section_modal mb_16 schedule_step"
      >
        <h4 class="heading_h4 font_bold mb_16">
          When would you like your report to be delivered?
        </h4>
        <div class="input_wrap">
          <custom-select
            v-model="modalSchedule.frequency"
            :options="{
              'once' : 'Once',
              'daily' : 'Daily',
              'weekly' : 'Weekly',
              'monthly' : 'Monthly',
            }"
            :width="modalSchedule.frequency !== 'once' ? 'full' : 'two-thirds'"
            label="Frequency"
          />

          <div
            v-if="modalSchedule.frequency === 'once'"
            class="checkbox_block third"
            style="margin-top: 45px;"
          >
            <input
              id="sendNow"
              v-model="sendNow"
              type="checkbox"
            >
            <label
              class="p_small"
              for="sendNow"
            >Send immediately?</label>
          </div>

          <date-picker
            v-if="!sendNow"
            id="startDate"
            v-model="modalSchedule.start_date"
            :format="report.date_format"
            :width="modalSchedule.frequency === 'once' ? 'half' : 'third'"
            label="Start Date"
          />

          <custom-select
            v-if="!sendNow"
            v-model="modalSchedule.time"
            :options="selectableTimes"
            :width="modalSchedule.frequency === 'once' ? 'half' : 'third'"
            label="Time of day ( GMT )"
          />

          <date-picker
            v-if="modalSchedule.frequency !== 'once'"
            id="endDate"
            v-model="modalSchedule.end_date"
            :format="report.date_format"
            :min-date="minDate"
            label="End Date"
            width="third"
          />

          <custom-select
            v-model="modalSchedule.date_range"
            :options="{
              'last_week': 'Last Week',
              'last_month': 'Last Month',
              'last_7_days': 'Last 7 days',
              'last_30_days' : 'Last 30 Days',
            }"
            label="Report Date Range"
            width="half"
          />

          <custom-select
            v-model="modalSchedule.compare_to"
            :can-clear="true"
            :options="{
              'previous_period': 'Previous Period',
              'previous_month': 'Previous Month',
              'previous_year': 'Previous Year'
            }"
            label="Compared to"
            placeholder="No Comparison"
            width="half"
          />

          <div class="dates_preview half">
            <span>Next delivery: </span> <span>{{ formatDateTime(nextDelivery) }}</span>
            <span>Report Date Range: </span> <span><span>{{
              formatDate(dates.fromDate)
            }}</span> to <span>{{ formatDate(dates.toDate) }}</span></span>
            <span v-if="modalSchedule.compare_to">Comparison Date Range:</span> <span
              v-if="modalSchedule.compare_to"
            > <span>{{
              formatDate(dates.compFromDate)
            }}</span> to <span>{{ formatDate(dates.compToDate) }}</span></span>
            <span v-if="modalSchedule.frequency !== 'once'">Last delivery:</span> <span
              v-if="modalSchedule.frequency !== 'once'"
            >{{ formatDateTime(lastDelivery) }}</span>
          </div>
        </div>
      </div>

      <div
        v-if="currentStep === 2"
        class="section_modal_content white_box edit_section_modal mb_16 schedule_step"
      >
        <h4 class="heading_h4 font_bold mb_16">
          What should the email say?
        </h4>
        <div class="input_wrap">
          <custom-input
            v-model="report.custom_email.from_email"
            :disabled="true"
            :sub-label="user.custom_email_label"
            :validation-errors="errors.email_to"
            label="From Email Address"
            placeholder="example@example.com"
          />

          <custom-input
            v-model="modalSchedule.email_to"
            :validation-errors="errors.email_to"
            label="Recipient Email Address"
            placeholder="example@example.com"
            sub-label="Separate multiple email addresses with a semi-colon ( ; )"
          />

          <custom-input
            v-model="modalSchedule.email_cc"
            :validation-errors="errors.email_cc"
            label="CC Recipient Email Address"
            placeholder="email1@example.com; email2@example.com"
          />

          <custom-input
            v-model="modalSchedule.email_subject"
            :validation-errors="errors.email_subject"
            label="Subject"
            placeholder="Email subject"
          />

          <div class="checkbox_block mt_4">
            <input
              id="check_32423"
              v-model="modalSchedule.include_attachment"
              type="checkbox"
            >
            <label
              class="p_small"
              for="check_32423"
            >Attach report PDF?</label>
          </div>

          <div class="message_block">
            <div class="text_area">
              <custom-textarea
                v-model="modalSchedule.email_body"
                :font="report.font"
                :validation-errors="errors.email_body"
                label="Email Body"
                @changed="value => {!showRenderedMessage ? email_body = value : null; clearErrors('body');}"
              />
              <div class="checkbox_block mt_12">
                <button
                  class="btn btn_sm primary_btn"
                  @mousedown="showRenderedMessage()"
                  @mouseleave="hideRenderedMessage()"
                  @mouseup="hideRenderedMessage()"
                >
                  Click and hold to preview
                </button>
              </div>
            </div>
            <div class="placeholders">
              <ContentPlaceholders
                title="AUTO-FILL TAGS"
                :placeholders="placeholders"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="currentStep < 3"
        class="flex mt_24 items-center create_report_footer"
      >
        <div class="create_steps mr_auto flex items-center">
          <div :class="'step_item '+(currentStep === 1 ? 'current' : 'completed')">
            <i>1</i>
            <span>Setup Schedule</span>
          </div>
          <div :class="'step_item '+(currentStep === 2 ? 'current' : '')">
            <i>2</i>
            <span>Email</span>
          </div>
        </div>
        <div class="flex items-center">
          <button
            v-if="currentStep === 1"
            class="btn btn_md secondary_btn close_modal ml_auto mr_8"
            @click="$emit('close')"
          >
            <span>Cancel</span>
          </button>
          <button
            v-if="currentStep === 2"
            class="btn btn_md secondary_btn close_modal ml_auto mr_8"
            @click="currentStep = 1"
          >
            <span>Back</span>
          </button>
          <button
            v-if="currentStep === 1"
            class="btn btn_md primary_btn"
            @click="currentStep = 2"
          >
            <span>Continue</span>
          </button>
          <button
            v-if="currentStep === 2"
            class="btn btn_md primary_btn"
            @click="save()"
          >
            <span>Save</span>
          </button>
        </div>
      </div>

      <div
        v-show="currentStep >= 3"
        class="schedule_report_final report_final"
      >
        <div>
          <img
            alt=""
            src="/img/app.svg"
          >
        </div>
        <div
          v-if="currentStep === 3"
          class="heading_h3 font_bold mt_24"
        >
          Scheduling your report...
        </div>
        <div
          v-if="currentStep === 4"
          class="heading_h3 font_bold mt_24"
        >
          Schedule saved
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';
import _ from 'lodash';
import {mapActions, mapState} from 'vuex';
import CustomInput from '../../global/forms/CustomInput.vue';
import CustomSelect from '../../global/forms/CustomSelect.vue';
import CustomTextarea from '../../global/forms/CustomWysiwyg.vue';
import DatePicker from '../../global/forms/DatePicker.vue';
import ContentPlaceholders from "../../../../../js/components/global/assets/ContentPlaceholders.vue";

export default {
  components: {
    ContentPlaceholders,
    CustomInput,
    CustomSelect,
    CustomTextarea,
    DatePicker
  },
  emits: ['close'],
  data() {
    return {
      startDatepicker: false,
      endDatepicker: false,
      sendNow: false,
      currentStep: 1,
      errors: {},
      modalSchedule: {
        compare_to: null,
        date_range: 'last_month',
        frequency: 'monthly',
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(1, 'd').add(1, 'year').format('YYYY-MM-DD'),
        time: null,
        email_body: '<p>Hello Joe Bloggs,<br><br>Here is a link to preview the [[REPORT_LINK]] for [[FROM_DATE]] to [[TO_DATE]] that I have compiled for [[SIMPLE_URL]].<br><br>Sincerely, John Smith<br></p>',
        email_cc: '',
        email_subject: '',
        email_to: '',
        include_attachment: false,
        report_id: null
      },
      tempMessage: '',
      placeholders: {
        SIMPLE_URL: 'Simple URL',
        CURRENT_DATE: 'Current Date',
        FROM_DATE: 'Report Start Date',
        TO_DATE: 'Report End Date',
        COMP_RANGE: 'Comparison range',
        COMP_FROM: 'Comparison Start Date',
        COMP_TO: 'Comparison End Date',
        REPORT_LINK: 'Report Link',
        DOWNLOAD_LINK: 'PDF Download Link',
      },
      emailBodyHolder: ''
    }
  },
  computed: {
    ...mapState('report', ['report', 'schedule']),
    ...mapState('user', ['user']),
    selectableDates() {
      if (this.modalSchedule.frequency === 'monthly') {
        const dates = [];
        for (let i = 1; i <= 31; i++) {
          dates.push(i);
        }
        return dates
      } else {
        return {
          'monday': 'Monday',
          'tuesday': 'Tuesday',
          'wednesday': 'Wednesday',
          'thursday': 'Thursday',
          'friday': 'Friday',
          'saturday': 'Saturday',
          'sunday': 'Sunday'
        }
      }
    },
    selectableTimes() {
      let times = [];
      let time = moment().hour(0).minute(0);
      for (let i = 0; i < 96; i++) { // 96 = 24 hours * 4 to get 15m intervals
        let hour = {
          value: time.format('HH:mm'),
          label: time.format('HH:mm'),
          disabled: (moment(this.modalSchedule.start_date).isSame(moment(), 'day') && time < moment())
        }
        times.push(hour);
        time.add(15, 'm');
      }
      return times;
    },
    startTime() {
      const start = moment();
      const remainder = 15 - (start.minute() % 15);
      return moment().add(remainder, 'm').format('HH:mm');
    },
    dates() {
      let dates = {
        fromDate: '',
        toDate: '',
        compFromDate: '',
        compToDate: ''
      };

      switch (this.modalSchedule.date_range) {
        case 'last_week':
          dates.fromDate = moment(this.modalSchedule.next_delivery).subtract(7, 'd').startOf('isoWeek').format('YYYY-MM-DD');
          dates.toDate = moment(this.modalSchedule.next_delivery).subtract(7, 'd').endOf('isoWeek').format('YYYY-MM-DD');
          break;
        case 'last_fortnight':
          dates.fromDate = moment(this.modalSchedule.next_delivery).subtract(14, 'd').startOf('isoWeek').format('YYYY-MM-DD');
          dates.toDate = moment(this.modalSchedule.next_delivery).subtract(7, 'd').endOf('isoWeek').format('YYYY-MM-DD');
          break;
        case 'last_month':
          dates.fromDate = moment(this.modalSchedule.next_delivery).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
          dates.toDate = moment(this.modalSchedule.next_delivery).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
          break;
        case 'last_7_days':
          dates.fromDate = moment(this.modalSchedule.next_delivery).subtract(8, 'd').format('YYYY-MM-DD');
          dates.toDate = moment(this.modalSchedule.next_delivery).subtract(1, 'd').format('YYYY-MM-DD');
          break;
        case 'last_14_days':
          dates.fromDate = moment(this.modalSchedule.next_delivery).subtract(15, 'd').format('YYYY-MM-DD');
          dates.toDate = moment(this.modalSchedule.next_delivery).subtract(1, 'd').format('YYYY-MM-DD');
          break;
        case 'last_30_days':
          dates.fromDate = moment(this.modalSchedule.next_delivery).subtract(31, 'd').format('YYYY-MM-DD');
          dates.toDate = moment(this.modalSchedule.next_delivery).subtract(1, 'd').format('YYYY-MM-DD');
          break;
      }
      let diff = null;
      switch (this.modalSchedule.compare_to) {
        case 'previous_period':
          diff = moment(dates.toDate, 'YYYY-MM-DD').diff(moment(dates.fromDate, 'YYYY-MM-DD'), 'days');
          dates.compFromDate = moment(dates.fromDate, 'YYYY-MM-DD').subtract(diff + 1, 'd').format('YYYY-MM-DD');
          dates.compToDate = moment(dates.compFromDate, 'YYYY-MM-DD').add(diff, 'd').format('YYYY-MM-DD');
          break;
        case 'previous_month':
          dates.compFromDate = moment(dates.fromDate, 'YYYY-MM-DD').subtract(1, 'month').format('YYYY-MM-DD');
          dates.compToDate = moment(dates.toDate, 'YYYY-MM-DD').subtract(1, 'month').format('YYYY-MM-DD');
          break;
        case 'previous_year':
          dates.compFromDate = moment(dates.fromDate, 'YYYY-MM-DD').subtract(1, 'year').format('YYYY-MM-DD');
          dates.compToDate = moment(dates.toDate, 'YYYY-MM-DD').subtract(1, 'year').format('YYYY-MM-DD');
          break;
      }

      return dates;
    },
    renderedBody() {
      const placeholders = [
        '[[SIMPLE_URL]]',
        '[[CURRENT_DATE]]',
        '[[FROM_DATE]]',
        '[[TO_DATE]]',
        '[[COMP_RANGE]]',
        '[[COMP_FROM]]',
        '[[COMP_TO]]',
        '[[REPORT_LINK]]',
        '[[DOWNLOAD_LINK]]',
      ];

      let text = this.modalSchedule.email_body;
      _.forEach(placeholders, placeholder => {
        let re = new RegExp(this.escapeRegExp(placeholder), 'g');
        text = text.replace(re, this.formatPlaceholder(placeholder));
      })
      return text;
    },
    minDate() {
      if (this.modalSchedule.start_date) {
        let date = new Date(this.modalSchedule.start_date);
        date.setUTCDate(date.getUTCDate() + 1);
        return date;
      } else {
        return new Date();
      }
    },
    nextDelivery() {
      let date = moment(moment(this.modalSchedule.start_date).format('YYYY-MM-DD') + ' ' + this.modalSchedule.time, 'YYYY-MM-DD HH:mm:ss');

      if (date.isAfter(moment())) {
        // TODO: need to fix the side effects linting errors
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.modalSchedule.next_delivery = date.format('YYYY-MM-DD HH:mm:ss');
        return date.format('YYYY-MM-DD HH:mm:ss');
      } else {
        switch (this.modalSchedule.frequency) {
          case 'once':
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.modalSchedule.next_delivery = moment().format('YYYY-MM-DD HH:mm:ss');
            return moment().format('YYYY-MM-DD HH:mm:ss');
          case 'daily':
            while (date.isBefore(moment())) {
              date.add(1, 'd');
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.modalSchedule.next_delivery = date.format('YYYY-MM-DD HH:mm:ss');
            return date.format('YYYY-MM-DD HH:mm:ss');
          case 'weekly':
            while (date.isBefore(moment())) {
              date.add(1, 'w');
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.modalSchedule.next_delivery = date.format('YYYY-MM-DD HH:mm:ss');
            return date.format('YYYY-MM-DD HH:mm:ss');
          case 'monthly':
            while (date.isBefore(moment())) {
              date.add(1, 'M');
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.modalSchedule.next_delivery = date.format('YYYY-MM-DD HH:mm:ss');
            return date.format('YYYY-MM-DD HH:mm:ss');
          default:
            return date.format('YYYY-MM-DD HH:mm:ss');
        }
      }
    },
    lastDelivery() {
      return moment(moment(this.modalSchedule.end_date).format('YYYY-MM-DD') + ' ' + this.modalSchedule.time, 'YYYY-MM-DD HH:mm A').format('YYYY-MM-DD HH:mm:ss');
    },
  },
  watch: {
    'sendNow': {
      handler(a) {
        if (a) {
          this.modalSchedule.start_date = moment().format('YYYY-MM-DD');
          this.modalSchedule.time = moment().format('HH:mm:ss');
        } else {
          this.modalSchedule.start_date = moment().format('YYYY-MM-DD');
          this.modalSchedule.time = this.startTime;
        }
      }
    },
  },
  beforeMount() {
    if (this.schedule) {
      _.merge(this.modalSchedule, this.schedule);
      this.modalSchedule.time = moment(this.schedule.start_date).format('HH:mm');
      this.modalSchedule.email_to = this.schedule.email_to ? this.schedule.email_to.join('; ') : '';
      this.modalSchedule.email_cc = this.schedule.email_cc ? this.schedule.email_cc.join('; ') : '';
    }
  },
  mounted() {
    if (!this.modalSchedule.time) this.modalSchedule.time = this.startTime;
  },
  methods: {
    ...mapActions('report', ['saveSchedule']),
    clearErrors(field) {
      delete this.errors[field];
    },
    showRenderedMessage() {
      this.emailBodyHolder = _.clone(this.modalSchedule.email_body);
      this.$nextTick(() => {
        $('#trumbowyg').trumbowyg('html', this.renderedBody);
      })
    },
    hideRenderedMessage() {
      if (this.emailBodyHolder) $('#trumbowyg').trumbowyg('html', this.emailBodyHolder);
    },
    async save() {
      this.currentStep = 3;
      await this.saveSchedule(this.modalSchedule)
          .then(() => {
            this.currentStep = 4;
            setTimeout(() => {
              this.$emit('close');
            }, 1500);
          })
          .catch(errors => {
            this.errors = errors;
            this.currentStep = 2;
          });
    },
    copyPlaceholderToClipboard(placeholder) {
      navigator.clipboard.writeText(placeholder);
      document.getElementById(placeholder).innerHTML = 'Copied to your clipboard!';
      setTimeout(() => {
        document.getElementById(placeholder).innerHTML = this.placeholders[placeholder];
      }, 700);
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    formatPlaceholder(placeholder) {
      if (placeholder === '[[SIMPLE_URL]]') return this.report.simple_url;
      if (placeholder === '[[CURRENT_DATE]]') return moment().format(this.report.date_format);
      if (placeholder === '[[FROM_DATE]]') return moment(this.dates.fromDate, 'YYYY-MM-DD').format(this.report.date_format);
      if (placeholder === '[[TO_DATE]]') return moment(this.dates.toDate, 'YYYY-MM-DD').format(this.report.date_format);
      if (placeholder === '[[COMP_RANGE]]') return this.modalSchedule.compare_to ? this.modalSchedule.compare_to.replace('_', ' ') : 'No Comparison Selected';
      if (placeholder === '[[COMP_FROM]]') return moment(this.dates.compFromDate, 'YYYY-MM-DD').format(this.report.date_format);
      if (placeholder === '[[COMP_TO]]') return moment(this.dates.compToDate, 'YYYY-MM-DD').format(this.report.date_format);
      if (placeholder === '[[REPORT_LINK]]') return `<a href="${this.report.preview_url}">${this.report.name}</a>`;
      if (placeholder === '[[DOWNLOAD_LINK]]') return `<a href="${this.report.preview_url}">download</a>`;
    },
    deslug(string) {
      return string.replace('_', ' ');
    },
    formatDate(date) {
      return moment(date).format(this.report.date_format);
    },
    formatDateTime(date) {
      return moment(date).format(this.report.date_format + ' HH:mm');
    },
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />

<style scoped>
.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.input_wrap, .advanced_options, .custom_daterange {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.datepicker_input {
  position: relative;
}

.open-datepicker {
  height: 48px !important;
  margin: auto 0 1.5rem 0;
  transition: 0ms !important;
}

.dates_preview {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.dates_preview > span {
  width: 50%;
  text-align: left;
  font-size: .75rem;
  line-height: 1.25;
}

.dates_preview > span:nth-child(odd) {
  font-weight: 500;
}

.dates_preview > span:nth-child(even) {
  text-align: right;
}

.message_block {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.message_block .preview {
  width: 100%;
  height: 100%;
  background: white;
  overflow: scroll;
}

.text_area {
  width: 70%;
}

</style>
